/* BaseActivityViewColumnComponent.js */

"use strict";

const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;
const _ = require("lodash");

class BaseActivityViewColumnComponent extends DefaultColumnComponent {
    constructor(activityEntity) {
        super(activityEntity);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    _normalizeCreateActivity(activityEntity) {
        let actvty = {};
        _.set(actvty, "activityType.activityType", "note");
        _.set(actvty, "activityType.tooltip", `Catalog created by (${activityEntity.createdBy}).`);
        _.set(actvty, "description.description", `Catalog created by user (${activityEntity.createdBy}).`);
        _.set(actvty, "status", "clean");
        return actvty;
    }

    _normalizeUpdateActivity(activityEntity) {
        let actvty = {};
        let jobName = activityEntity.getProperty("jobTypeName");
        jobName = _.titleize(_.humanize(jobName));
        if (jobName) {
            _.set(actvty, "activityType.activityType", "system");
            _.set(actvty, "activityType.tooltip", `Job (${jobName}) launched by ${activityEntity.createdBy}.`);
            _.set(actvty, "status", "clean");
            _.set(actvty, "description.description", `Catalog updated by job (${jobName}).`);
            let jobId = activityEntity.getProperty("jobId");
            _.set(actvty, "actions.viewMore", { logId: jobId });
        } else {
            let activityDescription;
            if (!activityDescription) {
                let nodeLinkPatch = _.find(activityEntity.patch, {
                    op: "add",
                    path: "/uniqueProp"
                });
                if (nodeLinkPatch) {
                    _.set(actvty, "activityType.activityType", "system");
                    activityDescription = "A Node has been created from the Catalog.";
                }
            }
            if (!activityDescription) {
                let auditStatusPatch = _.find(activityEntity.patch, { path: "/auditStatus" });
                if (auditStatusPatch) {
                    _.set(actvty, "activityType.activityType", "system");
                    switch (auditStatusPatch.value) {
                        case "RUNNING":
                            activityDescription = "A Configuration Audit has started.";
                            break;
                        case "PASSED":
                            activityDescription = "The Catalog passed the Configuration Audit.";
                            break;
                        case "FAILED":
                            activityDescription = "The Catalog failed the Configuration Audit.";
                            break;
                        case "ERROR":
                            activityDescription = "The Configuration Audit encountered an error.";
                            break;
                    }
                }
            }
            if (!activityDescription) {
                _.set(actvty, "activityType.activityType", "note");
                activityDescription = `Catalog updated by (${activityEntity.createdBy}).`;
            }
            _.set(actvty, "activityType.tooltip", activityDescription);
            _.set(actvty, "description.description", activityDescription);
            _.set(actvty, "status", "clean");
        }
        return actvty;
    }

    _normalizeUnknownActivity(activityEntity) {
        let actvty = {};
        _.set(actvty, "activityType.activityType", "unknown");
        _.set(actvty, "activityType.tooltip", `Unknown activity initiated by ${activityEntity.createdBy}.`);
        _.set(actvty, "description.description", "Unknown Activity");
        _.set(actvty, "status", "clean");
        return actvty;
    }

    _normalizeActivity(activityEntity) {
        let activity;
        let activityType = activityEntity.getProperty("activityType");
        switch (activityType) {
            case "create":
                activity = this._normalizeCreateActivity(activityEntity);
                break;
            case "update":
                activity = this._normalizeUpdateActivity(activityEntity);
                break;
            case "relAdd":
                if (activityEntity.getProperty("rEntityType")) {
                    activity = this._normalizeImageActivity(activityEntity);
                }
                break;
        }
        if (activity) {
            let date =
                typeof activityEntity.createdOn !== "undefined"
                    ? new Date(activityEntity.createdOn).toLocaleDateString() + " " + new Date(activityEntity.createdOn).toLocaleTimeString()
                    : "No date time provided";
            _.set(activity, "snapshot.snapshot", date);
            _.set(activity, "id", activityEntity.id);
        }

        return activity;
    }

    _normalizeImageActivity(activity) {
        let entityType = _.titleize(_.humanize(activity.getProperty("rEntityType")));
        let relName = _.titleize(_.humanize(activity.getProperty("relName")));

        _.set(activity, "activityType.activityType", "note");
        _.set(activity, "activityType.tooltip", `OS Images updated by ${activity.createdBy}.`);
        _.set(activity, "status", "clean");
        _.set(activity, "description.description", `${entityType} has been updated in the ${relName} relationship.`);
        return activity;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = BaseActivityViewColumnComponent;
